/*
 * AuthGuard to ne used in the routing modules
 *
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services';
import {
  getRelativeUri,
  getReturnUriQueryParams
} from 'app/shared/lib';

@Injectable ( {
  providedIn: 'root'
} )
export class AuthGuard  {

  constructor( private router: Router,
               private authService: AuthService ) {
  }

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) {

    if ( this.authService.isAuthenticated ) {
      return true;
    }

    if ( state.url !== '/' && state.url !== '/login' ) {
      const queryParams = getReturnUriQueryParams ( route );

      this.router.navigate ( [ '/login' ], {
        queryParams,
        replaceUrl: false
      } );
    }
    return false;
  }
}
